import React from 'react'
import {
    Card,
    CardBody,
    
  } from "@material-tailwind/react";
export default function ACard (props) {
    return (
        <Card className=" md:mt-6 md:w-[100%] h-[80vh]">
        <CardBody className='p-0 md:p-6'>
            {props.children}
        </CardBody>
      </Card>
    );
}
